import React from 'react';

import { connect } from 'react-redux';

// LevelEditor imports
import BtnSave from './Buttons/save';
import BtnSettings from './Buttons/settings';

import GameKit from '../../../../GameKit';
import { PopupTypes } from '../../Popup/Enums';
import ButtonsContainer from '../../TestPlayer/buttonscontainer';

class BottomBar extends React.Component {
    constructor(props) {
        super(props);

        this.buttonClass = 'le-bottom-button';
    }

    handleKeyPress = e => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    };

    handleClick = () => {
        GameKit.levelEditor.startTest();
    };

    render = () => {
        const { bottomBar, popup } = this.props;

        if(popup.activeType !== PopupTypes.NONE) {
            return <></>;
        }

        return (
            <div id="level-editor-bottom-bar">
                <ButtonsContainer />
                <div className="bar">
                    <div className="info-text">
                        <p>{bottomBar.text}</p>
                    </div>
                    <div className="buttons">
                        <BtnSettings className={this.buttonClass} />
                        <BtnSave className={this.buttonClass} />
                    </div>
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    bottomBar: state.bottomBar,
    popup: state.popup
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BottomBar);
